import api from 'app/actions/api';
import action from 'app/common/lib/action';
import { removeToken } from 'app/common/lib/token';
import i18n from 'app/i18n';


export const ACCOUNT_REMOVE_REQUEST = 'profile/ACCOUNT_REMOVE_REQUEST';
export const ACCOUNT_REMOVE_SUCCESS = 'profile/ACCOUNT_REMOVE_SUCCESS';
export const ACCOUNT_REMOVE_FAILURE = 'profile/ACCOUNT_REMOVE_FAILURE';

/**
* Удаление аккаунта
*/
export const accountRemove = () => async (dispatch) => {
  dispatch(action(ACCOUNT_REMOVE_REQUEST));

  try {
    await api('account', 'delete');
    dispatch(action(ACCOUNT_REMOVE_SUCCESS));
    removeToken();
    return true;
  } catch (error) {
    dispatch(action(ACCOUNT_REMOVE_FAILURE, {
      err: i18n.t('profile:error_delete_account'),
      error,
    }));
    return false;
  }
};
